export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9418.147266e3.jpg";